export const TRUYENFULL_SELECTORS = {
  metadata: {
    title: "h3.title",
    author: ".info-holder a[itemprop='author']",
    description: ".desc-text",
    cover: ".info-holder .book img",
    genres: ".info-holder a[itemprop='genre']",
    statusFull: ".info-holder .text-success",
    statusOngoing: ".info-holder .text-primary",
  },
  toc: {
    listItem: ".list-chapter li a",
    paginationLinks: "ul.pagination li a",
    paginationActive: "ul.pagination li.active",
  },
  chapter: {
    body: "#chapter-c",
    adStrip: '#chapter-c [id^="ads-"]',
  },
} as const;
